import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { WebSdkApiModule } from '@backbase/foundation-ang/web-sdk';
import { TransactionSigningHelperService } from './helper/transaction-signing-helper.service';
// import { TransactionSigningConfig, TRANSACTION_SIGNING_CONFIG } from './transaction-signing.config';
import { TransactionSigningInterceptor } from './transaction-signing.interceptor';

/**
 * Module used to initialize Transaction Signing with a configuration
 */
@NgModule({
  imports: [CommonModule, WebSdkApiModule],
})
export class BnTransactionSigningModule {
  /**
   * Creates a configured TransactionSigningModule.
   *
   * This should be called only once per app.
   *
   * @usageNotes
   *
   * ### Example
   *
   * ```
   * @NgModule({
   *   imports: [
   *     TransactionSigningModule.withConfig({
   *        useRedirectFlow: false,
   *        interceptor: MyCustomInterceptor
   *     })
   *   ]
   * })
   * class AppModule {}
   * ```
   */
  static withConfig(): ModuleWithProviders<BnTransactionSigningModule> {
    return {
      ngModule: BnTransactionSigningModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TransactionSigningInterceptor,
          multi: true,
        },
        TransactionSigningHelperService,
      ],
    };
  }
}
